<template>
	<!-- WYSIWYG Editor -->
	<div class="editor mb-4">
		<editor-menu-bar class="editor-bar" :editor="editor">
			<div slot-scope="{ commands, isActive, focused, getMarkAttrs }">
				<!-- Image -->
				<label
					class="btn btn-plain mb-0"
					:class="{
						'is-loading': isUploading,
						'hidden': !isBarShow('image'),
					}"
					v-tooltip="'Add Image'">
					<i class="material-icons m-0">image</i>
					<input type="file" class="hidden" @change="onImageChange(commands.image, ...arguments)">
				</label>

				<!-- Bold -->
				<button
					type="button"
					class="btn btn-plain"
					:class="{
						'is-active': isActive.bold(),
						'hidden': !isBarShow('bold'),
					}"
					@click="commands.bold"
					v-tooltip="'Bold'">
					<i class="material-icons">format_bold</i>
				</button>

				<!-- Italic -->
				<button
					type="button"
					class="btn btn-plain"
					:class="{
						'is-active': isActive.italic(),
						'hidden': !isBarShow('italic'),
					}"
					@click="commands.italic"
					v-tooltip="'Italic'">
					<i class="material-icons">format_italic</i>
				</button>

				<!-- Underline -->
				<button
					type="button"
					class="btn btn-plain"
					:class="{
						'is-active': isActive.underline(),
						'hidden': !isBarShow('underline'),
					}"
					@click="commands.underline"
					v-tooltip="'Underline'">
					<i class="material-icons">format_underline</i>
				</button>

				<!-- Strike -->
				<button
					type="button"
					class="btn btn-plain"
					:class="{
						'is-active': isActive.strike(),
						'hidden': !isBarShow('strike'),
					}"
					@click="commands.strike"
					v-tooltip="'Strike'">
					<i class="material-icons">strikethrough_s</i>
				</button>

				<!-- Align - Left -->
				<button
					type="button"
					class="btn btn-plain"
					:class="{
						'is-active': getMarkAttrs('align') && getMarkAttrs('align').textAlign === 'left',
						'hidden': !isBarShow('align-left'),
					}"
					@click="commands.align({ textAlign: 'left' })"
					v-tooltip="'Align Left'">
					<i class="material-icons">format_align_left</i>
				</button>

				<!-- Align - Center -->
				<button
					type="button"
					class="btn btn-plain"
					:class="{
						'is-active': getMarkAttrs('align') && getMarkAttrs('align').textAlign === 'center',
						'hidden': !isBarShow('align-center'),
					}"
					@click="commands.align({ textAlign: 'center' })"
					v-tooltip="'Align Center'">
					<i class="material-icons">format_align_center</i>
				</button>

				<!-- Algin - Right -->
				<button
					type="button"
					class="btn btn-plain"
					:class="{
						'is-active': getMarkAttrs('align') && getMarkAttrs('align').textAlign === 'right',
						'hidden': !isBarShow('align-right'),
					}"
					@click="commands.align({ textAlign: 'right' })"
					v-tooltip="'Align Right'">
					<i class="material-icons">format_align_right</i>
				</button>

				<!-- P -->
				<button
					type="button"
					class="btn btn-plain hidden"
					:class="{
						'is-active': focused && isActive.paragraph(),
						'hidden': !isBarShow('paragraph'),
					}"
					@click="commands.paragraph()"
					v-tooltip="'Paragraph'">
					<span class="text">P</span>
				</button>

				<!-- H1 -->
				<button
					type="button"
					class="btn btn-plain"
					:class="{
						'is-active': isActive.heading({ level: 1 }),
						'hidden': !isBarShow('h1'),
					}"
					@click="commands.heading({ level: 1 })"
					v-tooltip="'Headline 1'">
					<span class="text">H1</span>
				</button>

				<!-- H2 -->
				<button
					type="button"
					class="btn btn-plain"
					:class="{
						'is-active': isActive.heading({ level: 2 }),
						'hidden': !isBarShow('h2'),
					}"
					@click="commands.heading({ level: 2 })"
					v-tooltip="'Headline 2'">
					<span class="text">H2</span>
				</button>

				<!-- H3 -->
				<button
					type="button"
					class="btn btn-plain"
					:class="{
						'is-active': isActive.heading({ level: 3 }),
						'hidden': !isBarShow('h3'),
					}"
					@click="commands.heading({ level: 3 })"
					v-tooltip="'Headline 3'">
					<span class="text">H3</span>
				</button>

				<!-- Bullet List -->
				<button
					type="button"
					class="btn btn-plain"
					:class="{
						'is-active': isActive.bullet_list(),
						'hidden': !isBarShow('bullet-list'),
					}"
					@click="commands.bullet_list()"
					v-tooltip="'Bullet List'">
					<i class="material-icons">format_list_bulleted</i>
				</button>

				<!-- Ordered List -->
				<button
					type="button"
					class="btn btn-plain"
					:class="{
						'is-active': isActive.ordered_list(),
						'hidden': !isBarShow('ordered-list'),
					}"
					@click="commands.ordered_list()"
					v-tooltip="'Number List'">
					<i class="material-icons">format_list_numbered</i>
				</button>

				<!-- link -->
				<button
					type="button"
					class="btn btn-plain"
					:class="{
						'is-active': isActive.link(),
						'hidden': !isBarShow('link'),
					}"
					@click="showLinkMenu(getMarkAttrs('link'))"
					v-tooltip="'Hyper Link'">
					<i class="material-icons">link</i>
				</button>

					<!-- YouTube Video -->
				<button
					type="button"
					class="btn btn-plain"
					v-tooltip="'Embed YouTube Video'"
					:class="{
						'hidden': !isBarShow('video'),
					}"
					@click="showVideoModal(commands.iframe)">
					<i class="material-icons">play_circle_filled</i>
				</button>

				<!-- color picker -->
				<input
					type="color"
					:value="getMarkAttrs('color') ? getMarkAttrs('color').color : ''"
					v-tooltip="'Color Picker'"
					:class="{
						'is-active': isActive.color(),
						'hidden': !isBarShow('color'),
					}"
					class="btn py-0 px-0 btn-plain input-color"
					@input="onInputColor(commands.color, ...arguments)"
				/>

				<!-- bg color picker -->
				<input
					type="color"
					:value="getMarkAttrs('backgroundColor') ? getMarkAttrs('backgroundColor').color : ''"
					v-tooltip="'Background Color Picker'"
					:class="{
						'is-active': isActive.backgroundColor(),
					}"
					class="btn py-0 px-0 btn-plain input-color hidden"
					@input="onInputColor(commands.backgroundColor, ...arguments)"
				/>
				<!-- 'hidden': !isBarShow('backgroundColor'), -->

			</div>
		</editor-menu-bar>

		<editor-menu-bubble class="menububble" :editor="editor" @hide="hideLinkMenu" v-slot="{ commands, isActive, getMarkAttrs, menu }">
			<div
				class="menububble"
				:class="{ 'is-active': menu.isActive }"
				:style="`left: ${menu.left}px; bottom: ${menu.bottom}px;`"
			>

				<form class="menububble__form" v-if="linkMenuIsActive" @submit.prevent="setLinkUrl(commands.link, linkUrl)">
					<input class="menububble__input" type="text" v-model="linkUrl" placeholder="https://" ref="linkInput" @keydown.esc="hideLinkMenu"/>
					<button class="menububble__button" @click="setLinkUrl(commands.link, linkUrl)" type="button">
						<i class="material-icons">link</i>
					</button>
				</form>

				<template v-else>
					<!-- <button
						type="button"
						class="btn btn-plain"
						:class="{
							'is-active': isActive.link(),
						}"
						@click="showLinkMenu(getMarkAttrs('link'))"
						v-tooltip="'Hyper Link'">
						<span>{{ isActive.link() ? 'Update Link' : 'Add Link'}}</span>
						<i class="material-icons">link</i>
					</button> -->
				</template>

			</div>
		</editor-menu-bubble>

		<editor-content
			class="editor-content"
			:editor="editor"
			spellcheck="false"
		/>

		<div class="modals">
			<video-modal
				@insert="addCommand"
				@close="isVideoModalVisible = false"
				v-if="isVideoModalVisible">
			</video-modal>
		</div>
	</div>
</template>

<script>
import {
	Editor,
	EditorContent,
	EditorMenuBar,
	EditorMenuBubble,
} from 'tiptap';
import {
	// Blockquote,
	// CodeBlock,
	// HardBreak,
	Heading,
	OrderedList,
	BulletList,
	ListItem,
	TodoItem,
	TodoList,
	Bold,
	Code,
	Italic,
	Link,
	Strike,
	Underline,
	History,
	Image,
} from 'tiptap-extensions';
import mediaApi from '@/api/media';
import Align from '@/lib/tiptap/align';
import Color from '@/lib/tiptap/color';
import BackgroundColor from '@/lib/tiptap/bgColor';
import Iframe from '@/lib/tiptap/iframe';
import {
	nl2p,
	// eslint-disable-next-line
	removeHtmlTags
	// eslint-disable-next-line
} from '@/lib/helper';
// eslint-disable-next-line
import VideoModal from '@/components/VideoModal.vue';

export default {
	name: 'ContentEditor',
	props: {
		value: {
			type: String,
			default: '',
		},
		showBars: {
			type: Array,
			default: () => [
				'image',
				'bold',
				'italic',
				'underline',
				'strike',
				'h1',
				'h2',
				'h3',
				'p',
				'align-right',
				'align-center',
				'align-left',
				'bullet-list',
				'oderdered-list',
				'video',
				'link',
			],
		},
		stripTags: {
			type: Boolean,
			default: false,
		},
		from: {
			type: String,
		},
	},
	components: {
		EditorContent,
		EditorMenuBar,
		EditorMenuBubble,
		VideoModal,
	},
	data() {
		return {
			editor: null,
			isUploading: false,
			command: null,
			isVideoModalVisible: false,
			color: '',
			bgColor: '',
			linkUrl: null,
			linkMenuIsActive: false,
		};
	},
	watch: {
		value(newValue) {
			if (this.from === 'funnel') {
				const html = this.editor.getHTML();
				if (html !== this.value) {
					this.editor.setContent(newValue);
				}
			}
		},
	},
	methods: {
		initEditor() {
			let content = this.value;
			const isFormatted = content.indexOf('<p>') === 0;
			if (!isFormatted) {
				content = nl2p(content);
			}
			// const content = this.value;
			const extensions = [
				// new Blockquote(),
				// new CodeBlock(),
				// new HardBreak(),
				new Heading({ levels: [1, 2, 3] }),
				new BulletList(),
				new OrderedList(),
				new ListItem(),
				new TodoItem(),
				new TodoList(),
				new Bold(),
				new Code(),
				new Italic(),
				new Link(),
				new Strike(),
				new Underline(),
				new History(),
				new Image(),
				new Align(),
				new Color(),
				new Iframe(),
				new BackgroundColor(),
			];
			this.editor = new Editor({
				content,
				extensions,
				// disablePasteRules: true,
				onUpdate: this.onUpdate,
				onFocus: this.onFocus,
				// onPaste: this.onPaste,
			});
		},
		onUpdate(editor) {
			const content = editor.getHTML();
			this.$emit('input', content);
		},
		// eslint-disable-next-line
		onPaste(view, event, slice, moved = false) {
			console.log('view, event, slice: ', view, event, slice);
			const textHTML = event.clipboardData.getData('text/html');
			// const textString = event.clipboardData.getData('text/plain');
			let content = this.editor.getHTML();
			content = content.replace(textHTML, '');
			console.log('content: ', content);
			this.editor.setContent(content);
			// const fullContent = `${content} ${textString}`;
			// this.editor.setContent(fullContent);
			// this.$emit('input', fullContent);

			// navigator
			// navigator.clipboard.read()
			// 	// eslint-disable-next-line
			// 	.then((text) => {
			// 		console.log('text: ', text);
			// 		// let content = this.editor.getHTML();
			// 		// content = content.replace(text, '');
			// 		// content = `${content}<br/>${text}`;
			// 		// console.log('content: ', content);
			// 		// this.$emit('input', content);
			// 	})
			// 	.catch((err) => {
			// 		console.error('Failed to read clipboard contents: ', err);
			// 	});

			return true;
		},
		onImageChange(command, event) {
			const files = event.target.files;
			if (files.length > 0) {
				const file = files[0];

				const uploadParams = new FormData();
				uploadParams.append('image', file);
				uploadParams.append('resize', 0);

				this.isUploading = true;

				const callback = (response) => {
					const path = response.data;
					// const originalPath = path.replace('.', '-large.');
					const imageUrl = `${this.mediaUrlPrefix}/${path}`;
					command({ src: imageUrl });
					this.isUploading = false;
				};

				const errorCallback = () => {
					this.isUploading = false;
				};

				// Upload Image
				mediaApi.uploadImage(uploadParams, callback, errorCallback);
			}
		},
		insert(text) {
			const { selection, state } = this.editor;
			console.log('selection: ', state);
			const { from, to } = selection;
			const transaction = state.tr.insertText(text, from, to);
			this.editor.view.dispatch(transaction);
			// state.doc.textBetween(from, to, null, text);
			// const oldContent = this.editor.getHTML();
			// const newContent = oldContent.substring(0, from) + text + oldContent.substring(to, oldContent.length);
			// this.$emit('input', newContent);
			// this.editor.setContent(newContent, false);
		},
		onFocus() {
			this.$emit('focus');
		},
		showVideoModal(command) {
			this.command = command;
			this.isVideoModalVisible = true;
		},
		addCommand(data) {
			if (this.command !== null) {
				this.command(data);
			}
			this.isVideoModalVisible = false;
		},
		isBarShow(bar) {
			return this.showBars.includes(bar);
		},
		onInputColor(command, e) {
			const color = e.target.value;
			command({ color });
		},
		showLinkMenu(attrs) {
			this.linkUrl = attrs.href;
			this.linkMenuIsActive = true;
			this.$nextTick(() => {
				this.$refs.linkInput.focus();
			});
		},
		hideLinkMenu() {
			this.linkUrl = null;
			this.linkMenuIsActive = false;
		},
		setLinkUrl(command, url) {
			command({ href: url });
			this.hideLinkMenu();
		},
	},
	mounted() {
		this.initEditor();
	},
	beforeDestroy() {
		this.editor.destroy();
	},
};
</script>

<style lang="scss">
$color__accent: #fa962b;

.editor-bar {
	margin-bottom: .5em;

	.btn {
		margin-right: .5em;
		padding: .175rem .35rem;
		min-width: 30px;
		// color: $color__accent;

		&:hover {
			color: #fff;
			// background-color: #f5f5f5;
			background-color: $color__accent;
		}

		&.is-active {
			color: #fff;
			// background-color: #656565;
			background-color: $color__accent;
		}

		.material-icons {
			font-size: 1.25rem;
		}
	}
}

.ProseMirror {
	padding: 0.375rem 0.75rem;
	max-height: 300px;
	border-radius: 3px;
	background-color: #fcfcfc;
	border: 1px solid #d9dee2;
	overflow: auto;

	p {
		margin-bottom: .5em;
	}
}

.editor {
	.iframe {
		&__embed {
			width: 100%;
			height: 15rem;
			border: 0;
		}

		&__input {
			display: block;
			width: 100%;
			font: inherit;
			border: 0;
			border-radius: 5px;
			background-color: rgba(20, 20, 20, 0.1);
			padding: 0.3rem 0.5rem;
		}
	}


	.menububble {
		position: absolute;
		display: flex;
		z-index: 20;
		background: #495157;
		border-radius: 5px;
		margin-bottom: .5rem;
		transform: translateX(-50%);
		visibility: hidden;
		opacity: 0;
		transition: opacity .2s,visibility .2s;

		&.is-active {
			// padding: .3rem;
			opacity: 1;
			visibility: visible;
		}

		.menububble__button {
			display: -webkit-inline-box;
			display: inline-flex;
			background: transparent;
			border: 0;
			color: #fff;
			padding: .2rem .5rem;
			margin-left: .2rem;
			border-radius: 3px;
			cursor: pointer;

			&:last-child {
				margin-right: 0;
			}
		}

		.menububble__form {
			padding: .3rem .6rem;
			display: flex;
			align-items: center;
		}

		.menububble__input {
			font: inherit;
			border: none;
			background: #fff;
			color: #000;
			border-radius: 3px;
			padding: 2px 5px;
		}

	}

}
</style>
